module.exports = __webpack_public_path__ + "static/media/texture (14).90e8d966.jpg";